import { useField } from 'formik';

import { SupplierGroupSelect, type SupplierGroupSelectProps } from '../SupplierGroupSelect/SupplierGroupSelect';

interface FormikSupplierGroupSelectProps extends Omit<SupplierGroupSelectProps, 'onChange' | 'value'> {
    name: string;
    onGroupChange?: (value: string | null) => void;
}

export function FormikSupplierGroupSelect(props: FormikSupplierGroupSelectProps) {
    const [field, meta, helpers] = useField<string | null>(props.name);

    const onChange = (supplierGroupId: string | null) => {
        if (field.value !== supplierGroupId) {
            props.onGroupChange?.(supplierGroupId);
        }

        helpers.setValue(supplierGroupId);
    };

    return (
        <SupplierGroupSelect
            {...props}
            onChange={onChange}
            value={field.value}
            negative={meta.touched && !!meta.error}
            caption={meta.touched && meta.error ? meta.error : props.caption}
            onBlur={() => {
                helpers.setTouched(true);
            }}
        />
    );
}
